import fetchRetryFactory from 'fetch-retry';

const fetchRetry = fetchRetryFactory(fetch);

const apiUrl = import.meta.env.VITE_COMPASS_PRO_API;
const functionAppUrl = import.meta.env.VITE_FUNCTION_APP_URL;
const subscriptionKey = import.meta.env.VITE_SUBSCRIPTION_KEY;

export const fetchData = async (
  endpoint: string,
  bearerToken: string,
): Promise<Response> => {
  const response = await fetchRetry(`${apiUrl}${endpoint}`, {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
  });
  return response;
};

export const fetchFunctionAppData = async (
  endpoint: string,
  bearerToken: string,
) => {
  const response = await fetchRetry(`${functionAppUrl}${endpoint}`, {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
  });
  return response;
};

export const deleteJson = async (
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  return await doJsonMethod('DELETE', endpoint, json, bearerToken);
};
export const postJson = async (
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  return await doJsonMethod('POST', endpoint, json, bearerToken);
};
export const putJson = async (
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  return await doJsonMethod('PUT', endpoint, json, bearerToken);
};
export const postJsonWithFile = async (
  endpoint: string,
  file: File,
  bearerToken: string,
) => {
  return await doJsonMethodWithFile('POST', endpoint, file, bearerToken);
};

const doJsonMethod = async (
  methodType: string,
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  const response = await fetchRetry(`${apiUrl}${endpoint}`, {
    method: methodType,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
    body: JSON.stringify(json),
  });
  return response;
};

const doJsonMethodWithFile = async (
  methodType: string,
  endpoint: string,
  file: File,
  bearerToken: string,
) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetchRetry(`${apiUrl}${endpoint}`, {
    method: methodType,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
    body: formData,
  });
  return response;
};
